/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../utils/money';
import { HorseLink, OwnerLink, TrainerLink } from '../../shared/links/ProfileLink';
import StakeCell from '../../shared/cells/StakeCell';
import { numericAndDashSort } from '../../utils/number';

const columns = [
    {
        key: 'horseUid',
        header: 'horse',
        cell: ({ horse, horseName, horseUid }) => (
            <HorseLink
                horseStyleName={horse || horseName}
                horseUid={horseUid}
            />
        ),
    },
    {
        key: 'trainerStyleName',
        header: 'trainer',
        cell: ({ trainerName, trainerUid }) =>
            <TrainerLink trainerStyleName={trainerName} trainerUid={trainerUid} />,
    },
    {
        key: 'place1stNumber',
        header: 'wins',
    },
    {
        key: 'racesNumber',
        header: 'runs',
    },
    {
        key: 'rpr',
    },
    {
        key: 'totalPrize',
        header: 'total earnings',
        cell: ({ totalPrize }) => formatMoney(totalPrize),
        sortFn: numericAndDashSort('totalPrize'),
    },
    {
        key: 'winPrize',
        header: 'winnings',
        cell: ({ winPrize }) => formatMoney(winPrize),
    },
    {
        key: 'stake',
        header: '£1 stake',
        cell: StakeCell,
    },
];

const ownerColumn = {
    key: 'ownerStyleName',
    header: 'owner',
    cell: OwnerLink,
};

const columnsSet = {
    set default(cols) {
        this.default = cols;
    },
    get default() {
        delete this.default;

        this.default = columns;

        return this.default;
    },
    set trainer(cols) {
        this.trainer = cols;
    },
    get trainer() {
        delete this.trainer;
        const trainerColumnIndex = columns.findIndex(c => c.header === 'trainer');
        columns[trainerColumnIndex] = ownerColumn;
        this.trainer = columns;

        return this.trainer;
    },
};

export default columnsSet;



// WEBPACK FOOTER //
// ./src/js/human/horses/columns.jsx